import React from 'react';
import {
  Dialog,
  IconButton,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Close } from '@carbon/icons-react';

interface Props {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}
const PreviousDialog = ({ open, onOk, onClose }: Props) => {
  const classes = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <div className={classes.header}>
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          fontWeight="bold"
        >
          발주서 발행중
        </CustomizedTypography>
        <IconButton className="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.content}>
        <CustomizedTypography
          variant={matches ? 'body1' : 'h4'}
          color="textPrimary"
        >
          작성 중인 내용을 삭제하고 이전 견적을 불러와 새로 작성하시겠습니까?
        </CustomizedTypography>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          fullWidth
          variant="contained"
          color="default"
          onClick={onClose}
          size="large"
        >
          돌아가기
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={onOk}
          size="large"
        >
          새로 작성하기
        </CustomizedButton>
      </div>
    </Dialog>
  );
};

export default PreviousDialog;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 476,
    padding: 0,
    borderRadius: 16,
    '& h4': {
      wordBreak: 'break-all'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '28px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '28px 20px'
    },
    '& .close': {
      padding: 0,
      '& svg': {
        width: 24,
        height: 24
      }
    }
  },
  content: {
    padding: '0px 24px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px 24px'
    }
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    '& button': {
      width: 'calc(100% / 2 - 4px)'
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px'
    }
  }
}));
